import React from "react";

const CustomUnderline = () => (
  <svg
    width="100%"
    height="20" // Adjust height if needed
    viewBox="0 0 100 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Underline */}
    <rect width="100%" height="4" fill="#3f51b5" />
    {/* Triangle */}
    <polygon
      points="50,10 45,20 55,20"
      fill="#3f51b5" // Triangle color
    />
  </svg>
);

export default CustomUnderline;
